module.exports = __webpack_public_path__ + "static/media/24.c23c2432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/24.jpg
// module id = 557
// module chunks = 0